import React, {useState} from "react";
import {ReviewOverview} from "@App/types";
import {GarageProfileRatingContent} from "@App/components/GarageProfile/GaragProfileParts/GarageProfileRatingContent";
import {Text} from "@eo-locale/react";
import { format } from 'date-fns'
import Logo from "@App/public/assets/images/repareoshortlogo.svg";


export type GarageProfileRatingsProps = {
    ratingCount: number,
    averageRating: number,
    garageName: string
    ratings?: ReviewOverview
};

export const GarageProfileRatings = React.memo<GarageProfileRatingsProps>(({
                                                                               ratingCount,
                                                                               averageRating,
                                                                               garageName,
                                                                               ratings
                                                                           }) => {

    const itemsToShow = 3;

    const [next, setNext] = useState(itemsToShow);

    const displayMoreItems = () => {
        setNext(next + itemsToShow);
    };
    
    function daysAgo(date: Date) {
        var now = Date.now();
        var then = new Date(date);
        var timeDifference = now - then.getTime();
        var dayDifference = timeDifference / (1000 * 3600 * 24);
        return Math.round(dayDifference);
    }

    return (
        <div id={'reviews'} className={'col-span-full mb-16'}>
            <h2 className={'text-3xl font-serif text-gray-900 font-semibold'}>{ratingCount} <Text id={'ratings'}/></h2>
            <div className={'text-xl leading-7 font-serif text-gray-700 mb-6'}>{garageName}</div>

            <span className={'text-base leading-6 font-normal text-gray-900'}><b>{averageRating}%</b> <Text id={'recommendation'}/></span>
            <span className={'text-base leading-6 font-bold text-gray-900 flex items-center mt-1'}>
                <div className={`star-rating-${(Math.round((averageRating / 100 * 5) * 2) / 2).toFixed(1).split('.').join("")} !w-[104px] !h-[16px] inline-block mr-3`}/>
                {(averageRating / 100 * 5).toFixed(1)} von 5
                </span>

            <div className={'flex mb-4 mt-4'}>
                <span className={'grow-0 mr-2'} dangerouslySetInnerHTML={{__html: `5&nbsp;Sterne`}}/>
                <span className={'grow-1 w-full bg-gray-200 rounded-md'}>
                        <span className={`rounded-md bg-yellow-500 block h-full`} style={{width: `${ratings?.distribution.five.toFixed()}%`}}/>
                    </span>
                <span className={'grow-0 ml-2 min-w-[34px] text-right'} dangerouslySetInnerHTML={{__html: `${ratings?.distribution.five.toFixed()}&nbsp;%`}}/>
            </div>
            <div className={'flex mb-4'}>
                <span className={'grow-0 mr-2'} dangerouslySetInnerHTML={{__html: `4&nbsp;Sterne`}}/>
                <span className={'grow-1 w-full bg-gray-200 rounded-md'}>
                        <span className={`rounded-md bg-yellow-500 block h-full`} style={{width: `${ratings?.distribution.four.toFixed()}%`}}/>
                    </span>
                <span className={'grow-0 ml-2 min-w-[34px] text-right'} dangerouslySetInnerHTML={{__html: `${ratings?.distribution.four.toFixed()}&nbsp;%`}}/>
            </div>
            <div className={'flex mb-4'}>
                <span className={'grow-0 mr-2'} dangerouslySetInnerHTML={{__html: `3&nbsp;Sterne`}}/>
                <span className={'grow-1 w-full bg-gray-200 rounded-md'}>
                             <span className={`rounded-md bg-yellow-500 block h-full`} style={{width: `${ratings?.distribution.three.toFixed()}%`}}/>
                    </span>
                <span className={'grow-0 ml-2 min-w-[34px] text-right'} dangerouslySetInnerHTML={{__html: `${ratings?.distribution.three.toFixed()}&nbsp;%`}}/>
            </div>
            <div className={'flex mb-4'}>
                <span className={'grow-0 mr-2'} dangerouslySetInnerHTML={{__html: `2&nbsp;Sterne`}}/>
                <span className={'grow-1 w-full bg-gray-200 rounded-md'}>
                        <span className={`rounded-md bg-yellow-500 block h-full`} style={{width: `${ratings?.distribution.two.toFixed()}%`}}/>
                    </span>
                <span className={'grow-0 ml-2 min-w-[34px] text-right'} dangerouslySetInnerHTML={{__html: `${ratings?.distribution.two.toFixed()}&nbsp;%`}}/>
            </div>
            <div className={'flex mb-6'}>
                <span className={'grow-0 mr-2'} dangerouslySetInnerHTML={{__html: `1&nbsp;Sterne`}}/>
                <span className={'grow-1 w-full bg-gray-200 rounded-md'}>
                   <span className={`rounded-md bg-yellow-500 block h-full`} style={{width: `${ratings?.distribution.one.toFixed()}%`}}/>
                </span>
                <span className={'grow-0 ml-2 min-w-[34px] text-right'} dangerouslySetInnerHTML={{__html: `${ratings?.distribution.one.toFixed()}&nbsp;%`}}/>
            </div>

            {ratings && ratings.data.slice(0, next)?.map((item, index) => (
                <div key={index} className={'rating p-4 rounded-md border border-gray-200 mb-4'}>
                    <div className={'mb-2'}>
                        <div className={`star-rating-${(Math.round((item.rating / 100 * 5) * 2) / 2).toFixed(1).split('.').join("")} !w-[104px] !h-[16px] inline-block mr-3`}/>
                        {daysAgo(item.published_at) < 31 &&
                            <span
                                className={'inline-block float-right text-base leading-6 font-normal text-gray-500'}> vor {daysAgo(item.published_at)} Tagen</span>
                        }
                        {daysAgo(item.published_at) > 30 &&
                            <span
                                className={'inline-block float-right text-base leading-6 font-normal text-gray-500'}>{format(new Date(item.published_at), 'dd.MM.yyyy')}</span>
                        }
                    </div>
                    {item.comment &&
                        <GarageProfileRatingContent text={item.comment}/>
                    }
                    <div className={'flex items-center'}>
                    <span className={'text-base leading-6 font-bold'}>{item.author}</span>
                    {item.is_verified && (
                        <span className={'text-base leading-6 font-normal flex items-center text-gray-500 ml-2'}>
                           <span className={'text-2xl'}>·</span>
                            <picture className={'inline-block ml-2 mr-2'}>
                                <img
                                    src={Logo.src}
                                    alt="repareo.de Werkstattvergleich und Werkstattportal"
                                />
                            </picture> <Text id={'repareo_customer'}/></span>
                    )}
                    </div>
                </div>
            ))}

            {ratings && next < ratings?.data.length && (
                <button
                    className="text-base leading-6 font-medium text-gray-700 rounded-md border border-gray-200 p-2 mb-4"
                    onClick={displayMoreItems}
                >
                    <Text id={'show_more_ratings'}/>
                </button>
            )}
        </div>
    )

})

GarageProfileRatings.displayName = 'GarageProfileRatings';